/**
 * Loads the Trustpilot widget (TrustBox) inside this element when it's added to the page.
 *
 * The Trustpilot bootstrap script (html-bottom-trustpilot.liquid) only scans the page once on load.
 * Widgets inside the Product form or Add to cart bar are swapped by product-form.js on variant/product
 * change, and blocks are re-rendered in the theme editor, so those new widgets need to be loaded again.
 * Widgets the bootstrap script already loaded (they contain the iframe) are skipped.
 */
class TrustpilotWidget extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.trustpilot-widget').forEach((widget) => {
      if (widget.querySelector('iframe')) return;
      window.Trustpilot?.loadFromElement(widget, true);
    });
  }
}

customElements.define('trustpilot-widget', TrustpilotWidget);
